import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from "vue";
import TagSet from "src/shared/v-components/ui/tags/TagSet.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'IntegerListComponentVariableBuiltValue',
    props: {
        value: {}
    },
    setup(__props) {
        const props = __props;
        const isIntegerList = (value) => {
            return (Array.isArray(value) &&
                value.every((item) => !Number.isNaN(Number(item))));
        };
        const valueProxy = computed(() => {
            return isIntegerList(props.value) ? props.value : [];
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createCommentVNode(" Need this outer div to prevent ComponentVaribleValueInput props from colliding with TagSet props "),
                _createElementVNode("div", null, [
                    _createVNode(TagSet, {
                        tags: valueProxy.value,
                        bordered: true,
                        placeholder: '+ New Value',
                        readonly: true
                    }, null, 8 /* PROPS */, ["tags"])
                ])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */));
        };
    }
});
